import React, { useEffect, useState} from 'react'
import { Page, Text, View, Document, StyleSheet, Image, Font} from '@react-pdf/renderer'
import AuthService from "../../api/ApiRest";
//import QRCode from "react-qr-code";
//import QRCode from 'qrcode.react';
import Fondo from "../../assets/ctm_9.png"
import Logo_cfc from "../../assets/logo_ctm_2.png"
import Logo_cfc_2 from "../../assets/CFC-UNAP-PLOMO.png"
import Montserrat from "../../assets/fonts/Montserrat-Regular.ttf"
import MontserratM from "../../assets/fonts/Montserrat-Medium.ttf"
import MontserratB from "../../assets/fonts/Montserrat-Bold.ttf"
import OpenSans from "../../assets/fonts/OpenSans-Bold.ttf"
import {format, parseISO } from 'date-fns';
import {es} from 'date-fns/locale';
import { renderToStaticMarkup } from 'react-dom/server';
import QRCodeImage from './QrAbierto';
import firma_director from "../../assets/firma_director.png"
import firma_proyecto from "../../assets/firma_agustin_araya.png"

const DiplomaAbierto2025 = ({datos}) => {
    Font.register({
        family: 'OpenSans',
        src: OpenSans ,
      });
    Font.register({
        family: 'Montserrat',
        src: Montserrat ,
      });
    Font.register({
    family: 'MontserratM',
    src: MontserratM ,
    });
    Font.register({
        family: 'MontserratB',
        src: MontserratB ,
        });
    const [curso,setCurso]=useState([]);
    const [habilitado,setHabilitado]=useState(false);
    const [director,setDirector]=useState([]);
    const [directorS,setDirectorS]=useState([]);
    const [encargado,setEncargado]=useState([]);
    useEffect(()=>{
        
        const cursoData=async()=>{
            const response= await AuthService.getCursoAlumnoId(datos);
            setCurso(response.data.body[0])
        }
        cursoData();
        const firmaData=async()=>{
            const response= await AuthService.getFirmas();
            for (let index = 0; index < response.data.body.length; index++) {
                if(response.data.body[index].habilitado==='S'){
                    setHabilitado(true)
                }else{
                    setHabilitado(false)
                }
                if(response.data.body[index].cargo==='D'){
                    setDirector(response.data.body[index])
                }
                if(response.data.body[index].cargo==='S'){
                    setDirectorS(response.data.body[index])
                }
                if(response.data.body[index].cargo==='E'){
                    setEncargado(response.data.body[index])
                }
            }
        }
        firmaData();
    },[])
    //const qrContent=JSON.stringify(curso.folio);
      /*<QRCode
        size={256}
        style={{ height: "auto", maxWidth: "100%", width: "100%" }}
        value='holamundo'
        viewBox={`0 0 256 256`}
        /> */
        
    const capitalize=(str)=>{
        return str.charAt(0).toUpperCase()+str.slice(1);
    }
    function cambiarFormatoFecha(fecha,tipo){
        const fechaISO=parseISO(fecha);
        let fechaFormateada='';
        if(tipo==='dd'){
            fechaFormateada=format(fechaISO,'dd');
        }
        if(tipo==='MM'){
            fechaFormateada=capitalize(format(fechaISO,'MMMM',{locale:es}));
        }
        if(tipo==='yyyy'){
            fechaFormateada=format(fechaISO,'yyyy');
        }
        if(tipo==='dd-MM-yyyy'){
            fechaFormateada=format(fechaISO,'dd-MM-yyyy');
        }
        return fechaFormateada;
        }
        const [qrImage, setQrImage] = useState(null);

        const handleImageGenerated = (imageDataUrl) => {
          setQrImage(imageDataUrl);
        };
        const obtenerTextoFecha = (fechaInicio, fechaFin) => {
            if (!fechaInicio || !fechaFin) return '';
          
            // Crear fechas asegurando que se interpretan correctamente en la zona horaria local
            const fechaInicioObj = new Date(`${fechaInicio}T00:00:00`);
            const fechaFinObj = new Date(`${fechaFin}T00:00:00`);
          
            // Extraer mes y año correctamente
            const mesInicio = fechaInicioObj.toLocaleDateString('es-ES', { month: 'long' });
            const mesFin = fechaFinObj.toLocaleDateString('es-ES', { month: 'long' });
          
            const añoInicio = fechaInicioObj.getFullYear();
            const añoFin = fechaFinObj.getFullYear();
          
            if (mesInicio === mesFin && añoInicio === añoFin) {
              return `EN EL MES DE ${mesInicio} DEL ${añoInicio}`;
            } else if (añoInicio === añoFin) {
              return `ENTRE ${mesInicio} Y ${mesFin} DEL AÑO ${añoInicio}`;
            } else {
              return `ENTRE ${mesInicio} DEL AÑO ${añoInicio} A ${mesFin} DEL AÑO ${añoFin}`;
            }
          };        
    return (
        <Document>
            <Page  size="LETTER" orientation="landscape" style={styles.page}>
                <View style={styles.header} fixed>
                    <Image
                        src={Fondo}
                        style={styles.fondo}
                    />
                </View>
                <View style={{
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: 5,
                    }}
                    >
                    {/* Espacio vacío (izquierda) */}
                    <View style={{ width: 40 }} />  {/* ancho similar al logo */}

                    {/* Texto centrado */}
                    <View  style={[styles.subTitulo,{ flex: 1, alignItems: 'center',letterSpacing: 2,}]}>
                        <Text>EL CENTRO TECNOLÓGICO MINERO S.A. </Text>
                        <Text>OTORGA EL PRESENTE DIPLOMA A:</Text>
                    </View>
                    {/* Logo derecho */}
                    <Image src={Logo_cfc} style={{ width: 90, height: 90 }} />
                </View>
                
                <View  style={styles.alumno}>
                    <Text>{curso.nombre_alumno} {curso.primer_apellido} {curso.segundo_apellido}</Text>
                    <Text>RUT {curso.run?curso.run.toLocaleString('es-ES'):null}{curso.extranjero==='N' ?'-'+curso.dv:null}</Text>
                </View>
                <View  style={[styles.parrafo,{textAlign:'center',fontSize: 17,color: '#545454' } ]}>
                    <Text>POR SU PARTICIPACIÓN Y APROBACIÓN EN EL:</Text>
                </View>
                <View style={styles.curso}>
                    <Text>{curso.nombre_curso}</Text>
                </View>
                <View  style={[styles.subTitulo,{textAlign:'left',fontSize: 15 } ]}>
                    <Text>OBTENIENDO LA SIGUIENTE CALIFICACIÓN:</Text>
                </View>
                <View  style={[styles.parrafoBold,{marginTop:20} ]}>
                    <Text>RENDIMIENTO FINAL: {parseInt(curso.nota_final)}%</Text>
                    <Text>EVALUACIÓN FINAL  : {parseInt(curso.evaluacion_final)}%</Text>
                </View>

                <View style={[styles.parrafo,{fontSize: 13,marginTop:20,color: '#545454' } ]}>
                    <Text>ESTE CURSO FUE DICTADO  <Text style={[styles.parrafoBold,{ fontSize: 13, color: '#000000' }]}>{obtenerTextoFecha(curso.fecha_inicio_curso, curso.fecha_termino_curso).toUpperCase()}</Text>, CON UNA DURACIÓN</Text>
                    <Text>DE <Text style={[styles.parrafoBold,{ fontSize: 13, color: '#000000' }]}>{curso.horas_practica} HORAS</Text>.</Text>
                </View>

                
                <View  style={styles.firmas}>
                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                        <Image src={firma_proyecto} style={{ width: 80, height: 80 }} />
                        <Text style={styles.nombreFirma}>AGUSTÍN ARAYA URRUTIA</Text>
                        <Text style={styles.cargoFirma}>JEFE DE PROYECTOS</Text>
                    </View>
                    
                    <View style={{ flex: 1, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
                        <Image src={firma_director} style={{ width: 80, height: 80 }} />
                        <Text style={styles.nombreFirma}>{directorS.habilitado==='S'?directorS.nombre?.toUpperCase()+' '+directorS.primer_apellido?.toUpperCase()+' '+directorS.segundo_apellido?.toUpperCase():director.nombre?.toUpperCase()+' '+director.primer_apellido?.toUpperCase()+' '+director.segundo_apellido?.toUpperCase()}</Text>
                        <Text style={styles.cargoFirma}>DIRECTOR</Text>
                    </View>
                </View>
                <View
                    style={{
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        marginTop: 2,
                        paddingHorizontal: 10,
                      }}
                      fixed
                    >
                        
                    <View style={[styles.piePagina,{ flexDirection: 'column',marginTop: 5, }]}>
                        <Text>FOLIO Nº {curso.folio}/2025</Text>
                        <Text>FECHA DE EMISIÓN: {curso.fecha_actual}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', alignItems: 'center', gap: 10 }}>
                        <View>
                            <QRCodeImage datos={{url:`https://intranet.cfcunap.cl/diploma2/${curso.id}`}} />
                        </View>
                        <Image src={Logo_cfc_2} style={{ width: 65, height: 50 }} />
                    </View>
                </View>
            </Page>
        </Document>
    )
}
// Create styles                     <View style={{ flex: 0.5, flexDirection: 'column', justifyContent: 'space-between', alignItems: 'center', paddingHorizontal: 1 }}>
const styles = StyleSheet.create({
    page: {
        paddingTop: 25,
        paddingHorizontal: 45,
    },
    encabezado: {
        position: 'absolute', // Mantiene el encabezado fijo
        top: 0, // Lo posiciona en la parte superior
        left: 0,
        right: 0,
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
        paddingVertical: 20, // Espaciado vertical
        paddingHorizontal: 20, // Espaciado lateral
        backgroundColor: 'white', // Asegura que tenga un fondo visible
      },
    section: {
        margin: 10,
        padding: 10,
        flexGrow: 1
    },
    titulo:{
        fontFamily: 'Helvetica-Bold',
        fontSize: 16,
        textAlign: 'center',
        paddingTop: 70,
    },
    subTitulo:{
        fontFamily: 'MontserratB',
        fontSize: 16,
        textAlign: 'center',
        color: '#545454',
    },
    fondo:{
        width:"790px",
        height:"650px",
    },
    alumno:{
        paddingTop: 5,
        paddingBottom: 10,
        fontFamily: 'OpenSans',
        fontWeight: 'bold',
        fontSize: 27,
        textAlign: 'center'
    },
    parrafo:{
        fontFamily: 'Montserrat',
        fontSize: 15,
    },
    parrafoBold:{
        fontFamily: 'MontserratB',
        fontSize: 17,
    },
    curso:{
        fontFamily: 'OpenSans',
        fontWeight: 'bold',
        fontSize: 24,
        textAlign: 'center',
        marginBottom: 25
    },
    firmas:{
        flexDirection: 'row', 
        justifyContent: 'space-between', 
        alignItems: 'center', 
    },
    nombreFirma:{
        fontFamily: 'Helvetica-Bold',
        //fontWeight: 'bold',
        fontSize: 13,
    },
    cargoFirma:{
        fontFamily: 'Helvetica',
        //fontWeight: 'bold',
        fontSize: 13,
    },
    firmasNombre:{
        marginTop:25,
        fontFamily: 'Helvetica',
        fontSize: 14,
        textAlign: 'center',
        flexDirection:'row',
        justifyContent:'space-between',
    },
    firmasCargo:{
        fontFamily: 'Helvetica',
        fontSize: 14,
        textAlign: 'center',
        flexDirection:'row',
        justifyContent:'space-between',
    },
    textoIzquierda:{
        textAlign:'left',
    },
    textoDerecha: {
        textAlign: 'right',          // Alinea el texto a la derecha
        alignSelf: 'flex-end',       // Alinea el texto en la parte final del contenedor
        fontSize: 7,
        color: '#bf4e14',
      },
    header: {
        position: 'absolute',
        //marginBottom: 20,
      },
    piePagina: {
        //position: 'absolute',
        fontSize: 12,
        //bottom: 0,
        //left: 0,
        //right: 0,
        //paddingLeft: 40, // Margen izquierdo agregado
        textAlign: 'left',
        color: 'grey',
        //paddingVertical: 5, // Pequeño espacio para evitar corte de texto
      },
  });

export default DiplomaAbierto2025